import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'

// ------------------------------------
// Constants
// ------------------------------------
export const CRYPTO_PAY_RESULT = keyMirror({
  INIT_REQUEST: null,
  INIT_SUCCESS: null,
}, 'CRYPTO_PAY_RESULT')

// ------------------------------------
// Actions
// ------------------------------------
export function init(data) {
  return (dispatch, getState) => {
    return dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: data,
        errControl: true,
        endpoint: 'customerFrontend/cccashier/v1/unauth/getCashierSession',
        requestAction: CRYPTO_PAY_RESULT.INIT_REQUEST,
        successAction: CRYPTO_PAY_RESULT.INIT_SUCCESS,
        success: function(result) {},
      })
    )
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [CRYPTO_PAY_RESULT.INIT_REQUEST]: (state, action) => state,
  [CRYPTO_PAY_RESULT.INIT_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  isFetching: true
}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'cryptoPayResult',
    reducerMap: {
      cryptoPayResultState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
